module.exports = __webpack_public_path__ + "img/6_29.73b5a25f.png";